import { LogoutIcon } from "@root/assets/icons";
import { LANGUAGE, ROUTE_NAMES } from "@root/constants";
import useCustomTheme from "@root/hooks/useCustomTheme";
import useMediaQ from "@root/hooks/useMediaQ";
import {
  getLoggedInUser,
  selectChatsdownStatus,
  selectProfile,
  selectThreads,
} from "@root/store/selectors/entities";
import {
  updateChatPID,
  updateChatsDropdownStatus,
  updateCurrentThreadId,
  updateRiskCheckerSelectedFiles,
  updateRiskCheckerSelectedFilesURLs,
  updateThreadHistory,
  updateThreadList,
  updateThreads,
} from "@root/store/slices/entities";
import {
  deleteAccount,
  getThreads,
  getUserProfile,
  logout,
} from "@root/store/thunks";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useLanguage from "./useLanguage";
import { selectListThreads } from "@root/store/selectors/features";
import { useMainChatContext } from "@root/context/kps-chat-context";
import { DashboardIcon } from "@root/assets/icons/dashboardSidebarIcon";
import { RecentAssessmentIcon } from "@root/assets/icons/recent-assessment";
import { AskAIIcon } from "@root/assets/icons/Ask_ai";
import { MultiAIIcon } from "@root/assets/icons/multi-ai";
import { LegalComplianceIcon } from "@root/assets/icons/legal-compliance";

function useSidebar() {
  const isLoggedInUser: any = useSelector(getLoggedInUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isOpen, setisOpen] = useState(false);
  const threads: any = useSelector(selectThreads);
  const chatsDropdownStatus: boolean = useSelector(selectChatsdownStatus);
  const listThreads: any[] = useSelector(selectListThreads) || [];
  const { lg } = useMediaQ();
  const { isDarkTheme } = useCustomTheme();
  const { id } = useParams();
  const { pathname } = useLocation();
  const { handleUpdateLanguage, currentLanguage } = useLanguage();
  const {
    setCurrentMessageResponse,
    getInitialThreads: getInitialThreadsSidebar,
  } = useMainChatContext();

  const [logoutPopup, setLogoutPopup] = useState(false);
  const [deleteAccountPopup, setDeleteAccountPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const profileData = useSelector(selectProfile);
  const { t } = useTranslation("common");

  const getInitialThreads = () => {
    dispatch(
      getThreads({
        onSuccess: (res: any) => {
          dispatch(updateThreads(res));
        },
      })
    );
  };

  const getInitialData = () => {
    dispatch(getUserProfile({}));
  };

  useEffect(() => {
    getInitialData();
    getInitialThreads();
    getInitialThreadsSidebar();
  }, []);

  const sidebar = useMemo(() => {
    return [
      // {
      //   key: "dashboard",
      //   text: t("sidebar.dashboard"),
      //   active: false,
      //   iconComponent: DashboardIcon,
      //   onClick: () => navigate(ROUTE_NAMES.DASHBOARD),
      //   routes: [ROUTE_NAMES.DASHBOARD],
      // },
      // 👉 Section heading: LLM
      {
        key: "recent-assessment",
        text: t("sidebar.recentAssessment"),
        active: false,
        iconComponent: RecentAssessmentIcon,
        onClick: () => navigate(ROUTE_NAMES.RISK_ASSESSMENT),
        routes: [ROUTE_NAMES.RISK_ASSESSMENT],
      },
      {
        key: "ask-ai",
        text: t("sidebar.askAI"),
        active: false,
        iconComponent: AskAIIcon,
        onClick: () => navigate(ROUTE_NAMES.ASK_AI_CHATBOT),
        routes: [ROUTE_NAMES.ASK_AI_CHATBOT],
      },
      {
        key: "multi-ai",
        text: t("sidebar.multiAi"),
        active: false,
        iconComponent: MultiAIIcon,
        onClick: () => navigate(ROUTE_NAMES.MULTI_AI_CHATBOT),
        routes: [ROUTE_NAMES.MULTI_AI_CHATBOT],
      },
      {
        key: "legal-compliance",
        text: t("sidebar.legalCompliance"),
        active: false,
        iconComponent: LegalComplianceIcon,
        onClick: () => navigate(ROUTE_NAMES.LEGAL_COMPLIANCE),
        routes: [ROUTE_NAMES.LEGAL_COMPLIANCE],
      },
      // // 👉 Section heading: LLM
      // {
      //   key: "heading",
      //   text: "LLM",
      //   isHeading: true, // custom flag so UI renders differently
      // },

      // {
      //   key: "projectDocumentChatbot",
      //   text: t("sidebar.projectDocumentChatbot"),
      //   active: false,
      //   iconComponent: FolderIcon,
      //   onClick: () => navigate(ROUTE_NAMES.DOCUMENT_INTEGRATION_CHATBOT),
      //   routes: [ROUTE_NAMES.DOCUMENT_INTEGRATION_CHATBOT],
      // },
      // {
      //   key: "legalChatbot",
      //   text: t("sidebar.legalChatbot"),
      //   active: false,
      //   iconComponent: MessageIcon,
      //   onClick: () => navigate(ROUTE_NAMES.LEGAL_CHATBOT),
      //   routes: [ROUTE_NAMES.LEGAL_CHATBOT],
      // },
      // {
      //   key: "kcsChatbot",
      //   text: t("sidebar.kcsChatbot"),
      //   active: false,
      //   iconComponent: MessageIcon,
      //   onClick: () => navigate(ROUTE_NAMES.KCS),
      //   routes: [ROUTE_NAMES.KCS],
      // },
      // {
      //   key: "checklist",
      //   text: t("sidebar.checklist"),
      //   active: false,
      //   iconComponent: ChecklistIcon,
      //   onClick: () => navigate(ROUTE_NAMES.CHECKLIST),
      //   routes: [ROUTE_NAMES.CHECKLIST],
      // },
      // // Section heading: Agent
      // {
      //   key: "heading",
      //   text: "Agent",
      //   isHeading: true,
      // },
      // {
      //   key: "drawingAnalysisChatbot",
      //   text: t("sidebar.drawingAnalysisChatbot"),
      //   active: false,
      //   iconComponent: DrawingIcon,
      //   onClick: () => navigate(ROUTE_NAMES.DRAWING_ANALYSIS),
      //   routes: [ROUTE_NAMES.DRAWING_ANALYSIS],
      // },
      // {
      //   key: "permitReview",
      //   text: t("sidebar.permitReview"),
      //   active: false,
      //   iconComponent: CalendarIcon,
      //   onClick: () => navigate(ROUTE_NAMES.PERMIT_REVIEW),
      //   routes: [ROUTE_NAMES.PERMIT_REVIEW],
      // },
      // {
      //   key: "legalReview",
      //   text: t("sidebar.legalReview"),
      //   active: false,
      //   iconComponent: BalanceIcon,
      //   onClick: () => navigate(ROUTE_NAMES.LEGAL_REVIEW),
      //   routes: [ROUTE_NAMES.LEGAL_REVIEW],
      // },
      // {
      //   key: "materialComparison",
      //   text: t("sidebar.materialComparison"),
      //   active: false,
      //   iconComponent: MaterialIcon,
      //   onClick: () => navigate(ROUTE_NAMES.MATERIAL_CAMPARISON),
      //   routes: [ROUTE_NAMES.MATERIAL_CAMPARISON],
      // },
    ];
  }, [isLoggedInUser?.roleId, navigate, t]);

  const menuItemsList = [
    {
      title: t("sideMenu.Logout"),
      icon: LogoutIcon({ rotate: "180deg" }),
      onClick: () => setLogoutPopup(true),
      routes: [],
    },
  ];

  const languages = [
    {
      title: "ENG",
      value: "en",
      onClick: () => handleUpdateLanguage(LANGUAGE.ENGLISH),
      isActive: currentLanguage === LANGUAGE.ENGLISH,
    },
    {
      title: "KOR",
      value: "ko",
      onClick: () => handleUpdateLanguage(LANGUAGE.KOREAN),
      isActive: currentLanguage === LANGUAGE.KOREAN,
    },
  ];

  const clickOnAdd = () => {
    navigate(ROUTE_NAMES.LEGAL_CHATBOT);
    setCurrentMessageResponse(null);
    dispatch(updateThreadList([] as any));
    dispatch(updateRiskCheckerSelectedFilesURLs([] as any));
    dispatch(updateRiskCheckerSelectedFiles([] as any));
    dispatch(updateChatPID(null as any));
    dispatch(updateCurrentThreadId(null as any));
    dispatch(updateThreadHistory([] as any));
  };

  const clickOnCollapseArrow = (e: any) => {
    e.stopPropagation();
    dispatch(updateChatsDropdownStatus(!chatsDropdownStatus));
  };
  const clickOnCollapse = () => {
    dispatch(updateChatsDropdownStatus(false));
  };
  const logoutHandler = () => {
    dispatch(logout({}));
    navigate(ROUTE_NAMES.LOGIN);
  };

  const deleteUserAccount = () => {
    setLoading(true);
    dispatch(
      deleteAccount({
        onSuccess: () => {
          setLoading(false);
          logoutHandler();
        },
      })
    );
  };

  useEffect(() => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  }, [chatsDropdownStatus, pathname, currentLanguage]);

  return {
    isOpen,
    isDarkTheme,
    lg,
    navigate,
    dispatch,
    sidebar,
    pathname,
    chatsDropdownStatus,
    languages,
    menuItemsList,
    chatId: id,
    clickOnAdd,
    clickOnCollapseArrow,
    clickOnCollapse,
    threads,
    profileData,
    logoutPopup,
    setLogoutPopup,
    deleteAccountPopup,
    setDeleteAccountPopup,
    logoutHandler,
    deleteUserAccount,
    loading,
    setLoading,
    t,
    isMenuOpen,
    setIsMenuOpen,
  };
}

export default useSidebar;
